<script>
import config from "@/config.js";
export default {
  data: function () {
    return {
      navInfo: [
        {
          _name: "CSidebarNav",
          _children: [
            // Dashboard
            {
              _name: "CSidebarNavItem",
              name: "Dashboard",
              to: "/dashboard",
              icon: "cil-speedometer",
              condition: (permissions) =>
                permissions.includes("VIEW_DASHBOARD") &&
                !config.UNDER_DEVELOPMENT.includes("dashboard"),
            },

            // User Master
            {
              _name: "CSidebarNavDropdown",
              name: "User Master",
              icon: "cil-options",
              condition: (permissions) => {
                let requiredPermissions = [
                  "VIEW_USER_SEARCH",
                  "VIEW_USER_LIST",
                  "VIEW_DOCTOR_APPROVAL",
                  "VIEW_USERS_ACTIVITY",
                  "VIEW_CENTER_LIST",
                  "VIEW_CENTER_APPROVAL",
                  "VIEW_HOSPITAL_LISTING",
                  "VIEW_HOSPITAL_APPROVAL",
                ];
                return requiredPermissions.some(
                  (rP) =>
                    permissions.includes(rP) &&
                    !config.UNDER_DEVELOPMENT.includes("user_master")
                );
              },
              items: [
                {
                  name: "User Search",
                  to: "/user-list",
                  icon: "cil-file",
                  condition: (permissions) =>
                    permissions.includes("VIEW_USER_SEARCH"),
                },

                {
                  name: "User List",
                  to: "/userListing",
                  icon: "cil-file",
                  condition: (permissions) =>
                    permissions.includes("VIEW_USER_LIST"),
                },
                {
                  name: "staff List",
                  to: "/staffListing",
                  icon: "cil-file",
                  condition: (permissions) =>
                    permissions.includes("VIEW_USER_LIST"),
                },
                {
                  name: "Centre List",
                  to: "/centerListing",
                  icon: "cil-file",
                  condition: (permissions) =>
                    permissions.includes("VIEW_CENTER_LIST"),
                },
                {
                  name: "Doctor Approval",
                  to: "/doctor-list",
                  icon: "cil-file",
                  condition: (permissions) =>
                    permissions.includes("VIEW_DOCTOR_APPROVAL"),
                },
                {
                  name: "Allied Approval",
                  to: "/allied-list",
                  icon: "cil-file",
                  condition: (permissions) =>
                    permissions.includes("VIEW_DOCTOR_APPROVAL"),
                },
                {
                  name: "Centre Approval",
                  to: "/CentreApproval",
                  icon: "cil-file",
                  condition: (permissions) =>
                    permissions.includes("VIEW_CENTER_APPROVAL"),
                },
                {
                  name: "Users Activity",
                  to: "/usersActivity",
                  icon: "cil-file",
                  condition: (permissions) =>
                    permissions.includes("VIEW_USERS_ACTIVITY"),
                },
                {
                  name: "Hospital Listing",
                  to: "/hospitalListing",
                  icon: "cil-file",
                  // condition: (permissions) =>
                  //   permissions.includes("VIEW_HOSPITAL_LISTING"),
                },
                {
                  name: "Hospital Approval",
                  to: "/hospitalApprovalList",
                  icon: "cil-file",
                  condition: (permissions) =>
                    permissions.includes("VIEW_HOSPITAL_APPROVAL"),
                },
              ],
            },

            // Accounts
            {
              _name: "CSidebarNavDropdown",
              name: "Accounts",
              icon: "cil-options",
              condition: (permissions) => {
                let requiredPermissions = [
                  "VIEW_ACCOUNT_MASTER",
                  "VIEW_ACCOUNT_WITHDRAWAL_LIST",
                  "VIEW_ACCOUNT_SETTINGS",
                ];
                return requiredPermissions.some(
                  (rP) =>
                    permissions.includes(rP) &&
                    !config.UNDER_DEVELOPMENT.includes("accounts")
                );
              },
              items: [
                {
                  name: "Master",
                  to: "/accounts-master",
                  icon: "cil-file",
                  condition: (permissions) =>
                    permissions.includes("VIEW_ACCOUNT_MASTER"),
                },
                {
                  name: "Withdrawal List",
                  to: "/withdrawalList",
                  icon: "cil-file",
                  condition: (permissions) =>
                    permissions.includes("VIEW_ACCOUNT_WITHDRAWAL_LIST"),
                },
                {
                  name: "Settings",
                  to: "/accounts-settings",
                  icon: "cil-file",
                  condition: (permissions) =>
                    permissions.includes("VIEW_ACCOUNT_SETTINGS"),
                },
                {
                  name: "Corrupted Transactions",
                  to: "/corrupted-transactions",
                  icon: "cil-file",
                },
                // {
                //   name: "Refund Requests",
                //   to: "/refund-requests",
                //   icon: "cil-file",
                // },
              ],
            },
            //..........................................//
            {
              _name: "CSidebarNavDropdown",
              name: "Refund",
              icon: "cil-options",
              // condition: (permissions) => {
              //   let requiredPermissions = [
              //     "VIEW_ACCOUNT_MASTER",
              //     "VIEW_ACCOUNT_WITHDRAWAL_LIST",
              //     "VIEW_ACCOUNT_SETTINGS",
              //   ];
              //   return requiredPermissions.some(
              //     (rP) =>
              //       permissions.includes(rP) &&
              //       !config.UNDER_DEVELOPMENT.includes("accounts")
              //   );
              // },
              items: [
                {
                  name: "Online consultation",
                  to: "/online-consultation-refund",
                  icon: "cil-file",
                },
              ],
            },

            // User Request
            {
              _name: "CSidebarNavDropdown",
              name: "User Request",
              icon: "cil-options",
              condition: (permissions) => {
                let requiredPermissions = [
                  "VIEW_NAME_CHANGE_REQUEST",
                  "VIEW_RED_FLAG_REQUEST",
                ];
                return requiredPermissions.some(
                  (rP) =>
                    permissions.includes(rP) &&
                    !config.UNDER_DEVELOPMENT.includes("user_request")
                );
              },
              items: [
                {
                  name: "Name Change Request",
                  to: "/nameChangeList",
                  icon: "cil-file",
                  condition: (permissions) =>
                    permissions.includes("VIEW_NAME_CHANGE_REQUEST"),
                },

                {
                  name: "Red Flag Request",
                  to: "/red-flag",
                  icon: "cil-file",
                  condition: (permissions) =>
                    permissions.includes("VIEW_RED_FLAG_REQUEST"),
                },
              ],
            },

            // Customer Support
            {
              _name: "CSidebarNavDropdown",
              name: "Customer Support",
              icon: "cil-options",
              condition: (permissions) => {
                let requiredPermissions = [
                  "VIEW_CUSTOMER_TICKET_LIST",
                  "VIEW_REPORT_INAPPROPRIATE",
                  "VIEW_ASSIGNED_TICKETS",
                ];
                return requiredPermissions.some(
                  (rP) =>
                    permissions.includes(rP) &&
                    !config.UNDER_DEVELOPMENT.includes("customer_support")
                );
              },
              items: [
                {
                  name: "Customer Tickets List",
                  to: "/ticket-list",
                  icon: "cil-file",
                  condition: (permissions) =>
                    permissions.includes("VIEW_CUSTOMER_TICKET_LIST"),
                },

                {
                  name: "Report Inappropriate",
                  to: "/report-inappropriate",
                  icon: "cil-file",
                  condition: (permissions) =>
                    permissions.includes("VIEW_REPORT_INAPPROPRIATE"),
                },
                {
                  name: "Assigned Tickets",
                  to: "/assigned-tickets",
                  icon: "cil-file",
                  condition: (permissions) =>
                    permissions.includes("VIEW_ASSIGNED_TICKETS"),
                },
              ],
            },

            // Marketing Referral
            {
              _name: "CSidebarNavDropdown",
              name: "Marketing Referral",
              icon: "cil-options",
              condition: (permissions) => {
                let requiredPermissions = [
                  "VIEW_REFERRAL_MARKETING_AGENCIES",
                  "VIEW_REFERRED_MARKETING_USERS_LIST",
                ];
                return requiredPermissions.some(
                  (rP) =>
                    permissions.includes(rP) &&
                    !config.UNDER_DEVELOPMENT.includes("marketing_referral")
                );
              },

              items: [
                {
                  name: "Referral Marketing Agencies",
                  to: "/referral-marketing-agencies",
                  icon: "cil-speedometer",
                  condition: (permissions) =>
                    permissions.includes("VIEW_REFERRAL_MARKETING_AGENCIES"),
                },
                {
                  name: "Referred Marketing Users List",
                  to: "/referred-marketing-users-list",
                  icon: "cil-speedometer",
                  condition: (permissions) =>
                    permissions.includes("VIEW_REFERRED_MARKETING_USERS_LIST"),
                },
              ],
            },

            // User Referral
            {
              _name: "CSidebarNavDropdown",
              name: "User Referral",
              icon: "cil-options",
              condition: (permissions) => {
                let requiredPermissions = [
                  "VIEW_REFERRAL_DASHBOARD",
                  "VIEW_REFERRED_LIST",
                  "VIEW_REFERRED_LISTING",
                ];
                return requiredPermissions.some(
                  (rP) =>
                    permissions.includes(rP) &&
                    !config.UNDER_DEVELOPMENT.includes("user_referral")
                );
              },
              items: [
                {
                  name: "Referral Dashboard",
                  to: "/Referral-Dashboard",
                  icon: "cil-speedometer",
                  condition: (permissions) =>
                    permissions.includes("VIEW_REFERRAL_DASHBOARD"),
                },
                {
                  name: "Referred List",
                  to: "/Referred-List",
                  icon: "cil-speedometer",
                  condition: (permissions) =>
                    permissions.includes("VIEW_REFERRED_LIST"),
                },

                {
                  name: "Referred Listing",
                  to: "/Referred-Listing",
                  icon: "cil-speedometer",
                  condition: (permissions) =>
                    permissions.includes("VIEW_REFERRED_LISTING"),
                },
              ],
            },

            // Reports
            {
              _name: "CSidebarNavDropdown",
              name: "Reports",
              icon: "cil-options",
              condition: (permissions) => {
                let requiredPermissions = [
                  "VIEW_DOCTOR_DATA_REPORTS",
                  "VIEW_CITY_WISE_DOCTORS",
                ];
                return requiredPermissions.some(
                  (rP) =>
                    permissions.includes(rP) &&
                    !config.UNDER_DEVELOPMENT.includes("reports")
                );
              },

              items: [
                {
                  name: "Doctor Data Report",
                  to: "/doctor-data",
                  icon: "cil-speedometer",
                  condition: (permissions) =>
                    permissions.includes("VIEW_DOCTOR_DATA_REPORTS"),
                },
                {
                  name: "City-wise Doctors",
                  to: "/city-wise-doctors",
                  icon: "cil-speedometer",
                  condition: (permissions) =>
                    permissions.includes("VIEW_CITY_WISE_DOCTORS"),
                },
              ],
            },
            /* ........................................................................................ */
            {
              _name: "CSidebarNavDropdown",
              name: "Pay per use",
              condition: (permissions) =>
                permissions.includes("SHOW_PAY_PER_USE"),
              icon: "cil-options",
              items: [
                {
                  name: "Dashboard",
                  to: "/pay-per-use-dashboard",
                  icon: "cil-speedometer",
                },
                {
                  name: "Owner List",
                  to: "/owner-list",
                  icon: "cil-speedometer",
                },
                {
                  name: "Centre List",
                  to: "/centre-list",
                  icon: "cil-speedometer",
                },

                {
                  name: "Settings",
                  to: "/settings",
                  icon: "cil-speedometer",
                },
              ],
            },

            /* ........................................................................................ */
            {
              _name: "CSidebarNavDropdown",
              name: "SEVA",
              icon: "cil-options",
              condition: (permissions) =>
                permissions.includes("CAN_VIEW_SEVA") &&
                !config.UNDER_DEVELOPMENT.includes("seva"),
              items: [
                {
                  name: "Dashboard",
                  to: "/seva-dashboard",
                  icon: "cil-speedometer",
                },
                {
                  name: "Sathi Details",
                  to: "/sathi-table",
                  icon: "cil-speedometer",
                },
                {
                  name: "Subscriptions via DocSmart",
                  to: "/subscriptions-via-DocSmart",
                  icon: "cil-speedometer",
                },

                {
                  name: "Users by SEVA",
                  to: "/users-by-seva",
                  icon: "cil-speedometer",
                },
                {
                  name: "Payment List",
                  to: "/payment-list",
                  icon: "cil-speedometer",
                },
              ],
            },

            // Coupon Code
            // {
            //   _name: "CSidebarNavDropdown",
            //   name: "Coupon Code",
            //   icon: "cil-options",

            //   items: [
            //     {
            //       name: "Generated Coupons",
            //       to: "/generated-coupons",
            //       icon: "cil-speedometer"
            //     },
            //     {
            //       name: "Coupon Transaction History",
            //       to: "/coupon-transaction-history",
            //       icon: "cil-speedometer"
            //     }
            //   ]
            // },

            {
              _name: "CSidebarNavDropdown",
              name: "Employee Benefit Program",
              icon: "cil-options",
              condition: (permissions) => {
                let requiredPermissions = [
                  "VIEW_ENROLLED_ORGANIZATIONS",
                  "VIEW_USAGE_HISTORY",
                ];
                return requiredPermissions.some(
                  (rP) =>
                    permissions.includes(rP) &&
                    !config.UNDER_DEVELOPMENT.includes(
                      "employee_benefit_program"
                    )
                );
              },
              items: [
                {
                  name: "Enrolled Organizations",
                  to: "/enrolled-organizations",
                  icon: "cil-speedometer",
                  condition: (permissions) =>
                    permissions.includes("VIEW_ENROLLED_ORGANIZATIONS"),
                },
                {
                  name: "Usage History",
                  to: "/enrolled-coupontransaction-history",
                  icon: "cil-speedometer",
                  condition: (permissions) =>
                    permissions.includes("VIEW_USAGE_HISTORY"),
                },
              ],
            },

            // Accounts Masters
            {
              _name: "CSidebarNavDropdown",
              name: "Accounts Masters",
              icon: "cil-options",
              condition: (permissions) => {
                let requiredPermissions = [
                  "VIEW_DOCTOR_DATA_REPORTS",
                  "VIEW_CITY_WISE_DOCTORS",
                ];
                // return requiredPermissions.some(
                //   (rP) =>
                //     permissions.includes(rP) &&
                //     !config.UNDER_DEVELOPMENT.includes("accounts_masters")
                // );

                return requiredPermissions.some((rP) =>
                  permissions.includes(rP)
                );
              },

              items: [
                {
                  name: "DocSmart Dashboard",
                  to: "/docsmart-dashboard",
                  icon: "cil-speedometer",
                  // condition: permissions =>
                  //   permissions.includes("VIEW_DOCTOR_DATA_REPORTS")
                },
                {
                  name: "Subscription Masters",
                  to: "/subscription-masters",
                  icon: "cil-speedometer",
                  // condition: permissions =>
                  //   permissions.includes("VIEW_CITY_WISE_DOCTORS")
                },
                {
                  name: "Services Dashboard",
                  to: "/services-dashboard",
                  icon: "cil-speedometer",
                  // condition: permissions =>
                  //   permissions.includes("VIEW_CITY_WISE_DOCTORS")
                },
                {
                  name: "User Data",
                  to: "/user-data",
                  icon: "cil-speedometer",
                  // condition: permissions =>
                  //   permissions.includes("VIEW_CITY_WISE_DOCTORS")
                },
              ],
            },
            // Push Notification
            {
              _name: "CSidebarNavItem",
              name: "Push Notification",
              to: "/push-notification",
              icon: "cil-speedometer",
              condition: (permissions) =>
                permissions.includes("VIEW_PUSH_NOTIFICATION") &&
                !config.UNDER_DEVELOPMENT.includes("push_notification"),
            },
            // Push Notification
            {
              _name: "CSidebarNavItem",
              name: "User Registration OTPs",
              to: "/getOtp",
              icon: "cil-speedometer",
              condition: (permissions) =>
                permissions.includes("VIEW_USER_REGISTRATION_OTP") &&
                !config.UNDER_DEVELOPMENT.includes("user_registration_otp"),
            },

            // CME Events
            {
              _name: "CSidebarNavItem",
              name: "CME Events",
              to: "/cme-list",
              icon: "cil-speedometer",
              condition: (permissions) =>
                permissions.includes("VIEW_CME_LISTING") &&
                !config.UNDER_DEVELOPMENT.includes("cme_events"),
            },

            // Blog Listing
            {
              _name: "CSidebarNavDropdown",
              name: "Blog Listing",
              icon: "cil-options",
              condition: (permissions) => {
                let requiredPermissions = [
                  "VIEW_ADMIN_BLOGS",
                  "VIEW_USER_BLOGS",
                ];
                return requiredPermissions.some(
                  (rP) =>
                    permissions.includes(rP) &&
                    !config.UNDER_DEVELOPMENT.includes("blog_listing")
                );
              },
              items: [
                {
                  name: "Admin Blogs",
                  to: "/blogs-listing",
                  icon: "cil-file",
                  condition: (permissions) =>
                    permissions.includes("VIEW_ADMIN_BLOGS"),
                },

                {
                  name: "User Blogs",
                  to: "/user-blog-list",
                  icon: "cil-file",
                  condition: (permissions) => {
                    return permissions.includes("VIEW_USER_BLOGS");
                  },
                },
              ],
            },

            // Subscription
            {
              _name: "CSidebarNavDropdown",
              name: "Subscription",
              icon: "cil-options",
              condition: (permissions) => {
                let requiredPermissions = [
                  "VIEW_SUBSCRIPTION_LIST",
                  "VIEW_SUBSCRIPTION_DASHBOARD",
                  "VIEW_SUBSCRIPTION_HISTORY",
                ];
                return requiredPermissions.some(
                  (rP) =>
                    permissions.includes(rP) &&
                    !config.UNDER_DEVELOPMENT.includes("subscription")
                );
              },
              items: [
                {
                  name: "Subscription Dashboard",
                  to: "/subscription-dashboard",
                  icon: "cil-speedometer",
                  condition: (permissions) =>
                    permissions.includes("VIEW_SUBSCRIPTION_DASHBOARD"),
                },
                {
                  name: "Subscription List",
                  to: "/subscription-list",
                  icon: "cil-speedometer",
                  condition: (permissions) =>
                    permissions.includes("VIEW_SUBSCRIPTION_LIST"),
                },
                {
                  name: "Subscription Reports",
                  to: "/subscription-reports",
                  icon: "cil-speedometer",
                  condition: (permissions) =>
                    permissions.includes("VIEW_SUBSCRIPTION_REPORTS"),
                },
                {
                  name: "Subscription Plans",
                  to: "/subscription-plans",
                  icon: "cil-speedometer",
                },
                // {
                //   name: "Subscription History",
                //   to: "/subscription-history",
                //   icon: "cil-speedometer",
                //   condition: (permissions) =>
                //     permissions.includes("VIEW_SUBSCRIPTION_HISTORY"),
                // },
              ],
            },

            // {
            //   _name: "CSidebarNavItem",
            //   name: "Recentlyexpired Subscriptions",
            //   to: "/recentlyexpired-subscriptions",
            //   icon: "cil-speedometer",

            //   condition: permissions =>
            //     permissions.includes("VIEW_BLOG_LISTING")
            // },

            // News Listing
            {
              _name: "CSidebarNavItem",
              name: "News Listing",
              to: "/newsListing",
              icon: "cil-speedometer",
              condition: (permissions) =>
                permissions.includes("VIEW_NEWS_LISTING") &&
                !config.UNDER_DEVELOPMENT.includes("news_listing"),
            },
            // Chat
            {
              _name: "CSidebarNavItem",
              name: "Chat",
              to: "/chats",
              icon: "cil-speedometer",
              condition: (permissions) =>
                permissions.includes("VIEW_CHAT") &&
                !config.UNDER_DEVELOPMENT.includes("chat"),
            },
            // Active Modules
            {
              _name: "CSidebarNavItem",
              name: "Active Modules",
              to: "/active-modules",
              icon: "cil-speedometer",
              condition: (permissions) =>
                permissions.includes("VIEW_ACTIVE_MODULE") &&
                !config.UNDER_DEVELOPMENT.includes("active_modules"),
            },

            // Role
            {
              _name: "CSidebarNavItem",
              name: "Role",
              to: "/role",
              icon: "cil-speedometer",
              condition: (permissions) =>
                permissions.includes("VIEW_ROLE") &&
                !config.UNDER_DEVELOPMENT.includes("role"),
            },

            // AdminUser
            {
              _name: "CSidebarNavItem",
              name: "AdminUser",
              to: "/admin-user",
              icon: "cil-speedometer",
              condition: (permissions) =>
                permissions.includes("VIEW_ADMIN_USER") &&
                !config.UNDER_DEVELOPMENT.includes("admin_user"),
            },

            // Master
            {
              _name: "CSidebarNavDropdown",
              name: "Master",
              icon: "cil-options",
              condition: (permissions) => {
                let requiredPermissions = [
                  "VIEW_DIAGNOSTIC_TESTS_MASTER",
                  "VIEW_DOCTOR_DOCSMART_TESTS_MASTER",
                  "VIEW_PHARMACY_MEDICINES_MASTER",
                  "VIEW_PHARMACY_DOCTOR_MEDICINES_MASTER",
                ];
                return requiredPermissions.some(
                  (rP) =>
                    permissions.includes(rP) &&
                    !config.UNDER_DEVELOPMENT.includes("master")
                );
              },
              items: [
                {
                  name: "Diagnostic Tests",
                  to: "/master/tests",
                  icon: "cil-file",
                  condition: (permissions) =>
                    permissions.includes("VIEW_DIAGNOSTIC_TESTS_MASTER"),
                },
                {
                  name: "Health Package",
                  to: "/health-package",
                  icon: "cil-file",
                  condition: (permissions) =>
                    permissions.includes("VIEW_DOCTOR_DOCSMART_TESTS_MASTER"),
                },
                {
                  name: "Docsmart Doctor Tests",
                  to: "/master/doctor-tests",
                  icon: "cil-file",
                  condition: (permissions) =>
                    permissions.includes("VIEW_DOCTOR_DOCSMART_TESTS_MASTER"),
                },
                {
                  name: "Pharmacy Medicines",
                  to: "/master/medicine",
                  icon: "cil-file",
                  condition: (permissions) =>
                    permissions.includes("VIEW_PHARMACY_MEDICINES_MASTER"),
                },
                {
                  name: "Pharmacy Doctor Medicines",
                  to: "/master/doctor-medicines",
                  icon: "cil-file",
                  condition: (permissions) =>
                    permissions.includes(
                      "VIEW_PHARMACY_DOCTOR_MEDICINES_MASTER"
                    ),
                },
              ],
            },

            // Logs
            {
              _name: "CSidebarNavDropdown",
              name: "Logs",
              icon: "cil-options",
              condition: (permissions) => {
                let requiredPermissions = [
                  "VIEW_DOCSMART_LOGS",
                  "VIEW_SMS_LOGS",
                  "VIEW_TRANSPORT_LOGS",
                  "VIEW_DIAGNOSTIC_LOGS",
                  "VIEW_PHARMACY_LOGS",
                  "VIEW_BLOOD_BANK_LOGS",
                  "VIEW_AMBULANCE_LOGS",
                ];
                return requiredPermissions.some(
                  (rP) =>
                    permissions.includes(rP) &&
                    !config.UNDER_DEVELOPMENT.includes("logs")
                );
              },
              items: [
                {
                  _name: "CSidebarNavItem",
                  name: "SMS",
                  to: "/sms-log",
                  icon: "cil-file",
                  condition: (permissions) =>
                    permissions.includes("VIEW_SMS_LOGS"),
                },
                {
                  _name: "CSidebarNavItem",
                  name: "Docsmart",
                  to: "/log-details",
                  icon: "cil-file",
                  condition: (permissions) =>
                    permissions.includes("VIEW_DOCSMART_LOGS"),
                },
                {
                  _name: "CSidebarNavItem",
                  name: "Transport",
                  to: "/log-transport",
                  icon: "cil-file",
                  condition: (permissions) =>
                    permissions.includes("VIEW_TRANSPORT_LOGS"),
                },
                {
                  _name: "CSidebarNavItem",
                  name: "Diagnostics",
                  to: "/logs/diagnostics",
                  icon: "cil-file",
                  condition: (permissions) =>
                    permissions.includes("VIEW_DIAGNOSTIC_LOGS"),
                },
                {
                  _name: "CSidebarNavItem",
                  name: "Pharmacy",
                  to: "/logs/pharmacy",
                  icon: "cil-file",
                  condition: (permissions) =>
                    permissions.includes("VIEW_PHARMACY_LOGS"),
                },
                {
                  _name: "CSidebarNavItem",
                  name: "Bloodbank",
                  to: "/logs/bloodbank",
                  icon: "cil-file",
                  condition: (permissions) =>
                    permissions.includes("VIEW_BLOOD_BANK_LOGS"),
                },
                {
                  _name: "CSidebarNavItem",
                  name: "Ambulance",
                  to: "/log-ambulance",
                  icon: "cil-file",
                  condition: (permissions) =>
                    permissions.includes("VIEW_AMBULANCE_LOGS"),
                },
              ],
            },

            // MobileVersion

            {
              _name: "CSidebarNavDropdown",
              name: "Release Management",
              icon: "cil-options",
              condition: (permissions) =>
              permissions.includes("VIEW_MOBILE_VERSION"),
              items: [
                {
                  name: "Releases",
                  to: "/release",
                  icon: "cil-speedometer",
                  condition: (permissions) =>
                    permissions.includes("VIEW_MOBILE_VERSION"),
                },
                {
                  name: "Mobile Version",
                  to: "/mobile-version",
                  icon: "cil-speedometer",
                  condition: (permissions) =>
                    permissions.includes("VIEW_MOBILE_VERSION"),
                },
              ],
            },
            // {
            //   _name: "CSidebarNavItem",
            //   name: "MobileVersion",
            //   to: "/mobile-version",
            //   icon: "cil-speedometer",
            //   condition: (permissions) =>
            //     permissions.includes("VIEW_MOBILE_VERSION") &&
            //     !config.UNDER_DEVELOPMENT.includes("mobile_version"),
            // },

            // Logs
            {
              _name: "CSidebarNavDropdown",
              name: "Import Centers",
              icon: "cil-options",
              condition: (permissions) => {
                let requiredPermissions = [
                  "IMPORT_PHARMACY_CENTERS",
                  "IMPORT_DIAGNOSTIC_CENTERS",
                  "IMPORT_AMBULANCE_CENTERS",
                ];
                return requiredPermissions.some(
                  (rP) =>
                    permissions.includes(rP) &&
                    !config.UNDER_DEVELOPMENT.includes("logs")
                );
              },
              items: [
                {
                  _name: "CSidebarNavItem",
                  name: "Pharmacy",
                  to: "/import-centers/pharmacy",
                  icon: "cil-file",
                  condition: (permissions) =>
                    permissions.includes("IMPORT_PHARMACY_CENTERS") &&
                    !config.UNDER_DEVELOPMENT.includes("mobile_version"),
                },
                {
                  _name: "CSidebarNavItem",
                  name: "Diagnostics",
                  to: "/import-centers/diagnostics-lab",
                  icon: "cil-file",
                  condition: (permissions) =>
                    permissions.includes("IMPORT_DIAGNOSTIC_CENTERS") &&
                    !config.UNDER_DEVELOPMENT.includes("mobile_version"),
                },
                {
                  _name: "CSidebarNavItem",
                  name: "Ambulance",
                  to: "/import-centers/ambulance",
                  icon: "cil-file",
                  condition: (permissions) =>
                    permissions.includes("IMPORT_AMBULANCE_CENTERS") &&
                    !config.UNDER_DEVELOPMENT.includes("mobile_version"),
                },
              ],
            },

            {
              _name: "CSidebarNavDropdown",
              name: "DocSmart Insurance",
              icon: "cil-options",
              condition: (permissions) => permissions.includes("VIEW_DOCSMART_INSURANCE"),
              items: [
                {
                  name: "Doctors",
                  to: "/insurance-doctor",
                  icon: "cil-file",
                  condition: (permissions) => permissions.includes("VIEW_DOCSMART_INSURANCE_DOCTOR"),

                },
                {
                  name: "Allied",
                  to: "/insurance-allied",
                  icon: "cil-file",
                  condition: (permissions) => permissions.includes("VIEW_DOCSMART_INSURANCE_ALLIED"),

                },
                {
                  name: "Pharmacy",
                  to: "/insurance-pharmacy",
                  icon: "cil-file",
                  condition: (permissions) => permissions.includes("VIEW_DOCSMART_INSURANCE_PHARMACY"),


                },
                {
                  name: "Ambulance",
                  to: "/insurance-ambulance",
                  icon: "cil-file",
                  condition: (permissions) => permissions.includes("VIEW_DOCSMART_INSURANCE_AMBULANCE"),

                },

                {
                  name: "Diagnostics-lab",
                  to: "/insurance-diagnostics-lab",
                  icon: "cil-file",
                  condition: (permissions) => permissions.includes("VIEW_DOCSMART_INSURANCE_DIAGNOSTICS"),

                },
              ],
            },
            // Documents
            {
              _name: "CSidebarNavItem",
              name: "Documents",
              to: "/documents",
              icon: "cil-speedometer",
              condition: (permissions) =>
                permissions.includes("VIEW_CHAT") &&
                !config.UNDER_DEVELOPMENT.includes("chat"),
            },
          ],
        },
      ],
    };
  },
};
</script>
